/* Rule-based preservation engine — the core differentiated IP.
   Ported verbatim from the prototype (HANDOFF.md §4: relocate, don't rebuild). */

import { categoryMeta } from "./categories.js";
import { statusMeta } from "./status.js";
import { MATERIAL_TIPS } from "./materials.js";
import { daysSince, addDays } from "./format.js";

/** Returns an ordered list of [label, value] pairs, tailored to the item's category. */
export function generatePreservationProfile(item) {
  const meta = categoryMeta(item.category);
  const materials = item.materials || {};
  const uvSensitive = meta.uvSensitive ? meta.uvSensitive(materials) : false;
  const oxidation = meta.oxidationSource && meta.oxidationSource(materials);
  const anySelected = Object.values(materials).some((arr) => (arr || []).length);
  const delicate = meta.delicate ? meta.delicate(materials) : false;

  const base = {
    "Storage Temperature": "65–72°F (18–22°C)",
    Humidity: delicate ? "40–50%" : "45–55%",
    "Cleaning Frequency": statusMeta(item.status).flightNote,
    "UV Exposure": uvSensitive ? "Avoid direct sunlight" : "Low sensitivity",
    "Oxidation Risk": oxidation ? "High" : anySelected ? "Medium" : "Low",
    "Yellowing Risk": uvSensitive ? "High" : "Low",
  };
  const extra = meta.extraProfile ? meta.extraProfile(materials) : {};
  return Object.entries({ ...base, ...extra });
}

/** Collects material-specific care tips across every group the item has selected. */
export function materialTipsFor(item) {
  const meta = categoryMeta(item.category);
  const materials = item.materials || {};
  const out = [];
  meta.groups.forEach((g) => {
    (materials[g.key] || []).forEach((m) => {
      if (MATERIAL_TIPS[m]) out.push([m, MATERIAL_TIPS[m]]);
    });
  });
  return out;
}

/** Derives cleaning/rotation due-dates from the item's wear-habit status. */
export function maintenanceStatus(item) {
  const s = statusMeta(item.status);
  const cleanDue = s.cleanDays != null && daysSince(item.lastCleaned || item.dateAdded) >= s.cleanDays;
  const rotateDue = s.rotateDays != null && daysSince(item.lastRotated || item.dateAdded) >= s.rotateDays;
  const nextCleanDate = s.cleanDays != null ? addDays(item.lastCleaned || item.dateAdded, s.cleanDays) : null;
  const nextRotateDate = s.rotateDays != null ? addDays(item.lastRotated || item.dateAdded, s.rotateDays) : null;
  return { statusMeta: s, cleanDue, rotateDue, nextCleanDate, nextRotateDate };
}
